import React from "react";

export default function ProductInventory({
    product,
    setProduct
}) {

    const update = (field, value) => {

        setProduct(prev => ({
            ...prev,
            [field]: value
        }));

    };

    return (

        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 24
            }}
        >

            <div>

                <h2
                    style={{
                        margin: 0
                    }}
                >
                    Inventory
                </h2>

                <p
                    style={{
                        color: "#666",
                        marginTop: 8
                    }}
                >
                    Manage stock, SKU, barcode and physical
                    product information.
                </p>

            </div>

            {/* Identification */}

            <section style={cardStyle}>

                <h3 style={headingStyle}>
                    Product Identification
                </h3>

                <div style={gridStyle}>

                    <Field
                        label="SKU"
                        value={product.sku}
                        onChange={value =>
                            update("sku", value)
                        }
                        placeholder="e.g. PROD-001"
                    />

                    <Field
                        label="Barcode"
                        value={product.barcode}
                        onChange={value =>
                            update("barcode", value)
                        }
                        placeholder="UPC / EAN / ISBN"
                    />

                </div>

            </section>

            {/* Stock */}

            <section style={cardStyle}>

                <h3 style={headingStyle}>
                    Stock Management
                </h3>

                <div style={gridStyle}>

                    <Field
                        label="Stock Quantity"
                        type="number"
                        value={product.stock ?? ""}
                        onChange={value =>
                            update("stock", value)
                        }
                    />

                    <Field
                        label="Low Stock Threshold"
                        type="number"
                        value={product.lowStock ?? ""}
                        onChange={value =>
                            update("lowStock", value)
                        }
                    />

                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 15,
                        marginTop: 20
                    }}
                >

                    <Toggle
                        label="Track Inventory"
                        checked={
                            !!product.trackInventory
                        }
                        onChange={value =>
                            update(
                                "trackInventory",
                                value
                            )
                        }
                    />

                    <Toggle
                        label="Allow Backorders"
                        checked={
                            !!product.allowBackorder
                        }
                        onChange={value =>
                            update(
                                "allowBackorder",
                                value
                            )
                        }
                    />

                </div>

            </section>

            {/* Physical */}

            <section style={cardStyle}>

                <h3 style={headingStyle}>
                    Physical Information
                </h3>

                <div style={gridStyle}>

                    <Field
                        label="Weight"
                        type="number"
                        value={product.weight ?? ""}
                        onChange={value =>
                            update("weight", value)
                        }
                        placeholder="e.g. 1.5"
                    />

                    <Field
                        label="Dimensions"
                        value={
                            product.length_width_height
                        }
                        onChange={value =>
                            update(
                                "length_width_height",
                                value
                            )
                        }
                        placeholder="Length × Width × Height"
                    />

                </div>

            </section>

        </div>

    );

}

function Field({
    label,
    value,
    onChange,
    type = "text",
    placeholder
}) {

    return (

        <div>

            <label
                style={{
                    display: "block",
                    fontWeight: 600,
                    fontSize: 14
                }}
            >
                {label}
            </label>

            <input
                type={type}
                value={value ?? ""}
                onChange={e =>
                    onChange(e.target.value)
                }
                placeholder={placeholder}
                style={inputStyle}
            />

        </div>

    );

}

function Toggle({
    label,
    checked,
    onChange
}) {

    return (

        <label
            style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                cursor: "pointer"
            }}
        >

            <input
                type="checkbox"
                checked={checked}
                onChange={e =>
                    onChange(e.target.checked)
                }
            />

            <span>
                {label}
            </span>

        </label>

    );

}

const cardStyle = {

    background: "#fff",
    borderRadius: 16,
    padding: 24,
    border: "1px solid #e5e7eb"

};

const headingStyle = {

    marginTop: 0,
    marginBottom: 20

};

const gridStyle = {

    display: "grid",
    gridTemplateColumns:
        "repeat(auto-fit,minmax(220px,1fr))",
    gap: 20

};

const inputStyle = {

    width: "100%",
    boxSizing: "border-box",
    marginTop: 8,
    padding: "12px 14px",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    fontSize: 15

};